import { defineModule } from "@motolynk/app-core";

import en from "./i18n/en.json";

/**
 * No pages of its own: other modules' forms (vendor registration, addresses, warehouses) use the
 * exported CountrySelect / StateSelect and PIN-code helpers. Bundling it loads the `geo` strings.
 */
export const geoModule = defineModule({
  name: "geo",
  label: "Geo (countries & states)",
  requires: ["core"],
  i18n: { en },
  admin: { routes: [], nav: [] },
  vendor: { routes: [], nav: [] },
});
